import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { assetInstanceQueryOptions } from "@/services/asset";

/**
 * Thin Asset layout under a ticket → record Assets tab.
 * Drawer chrome lives in the pathless `_drawer` layout.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/records/$recordId/workspace/assets/$assetId",
)({
	params: {
		parse: (params) => ({
			assetId: z.string().parse(params.assetId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(
			`/workspace/assets/${params.assetId}`,
		);
		if (exactRoot) {
			const q =
				typeof location.search === "object" &&
				location.search &&
				"q" in location.search &&
				typeof (location.search as { q?: unknown }).q === "string"
					? (location.search as { q: string }).q
					: undefined;
			throw redirect({
				to: "/web/$orgId/tickets/$ticketId/workspace/records/$recordId/workspace/assets/$assetId/details",
				params: {
					orgId: params.orgId,
					ticketId: params.ticketId,
					recordId: params.recordId,
					assetId: params.assetId,
				},
				search: { q },
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.prefetchQuery(
			assetInstanceQueryOptions.detail(params.assetId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: AssetIdLayout,
});

function AssetIdLayout() {
	return <Outlet />;
}
